export default "__VITE_ASSET__C69we_$X__"